module.exports = __webpack_public_path__ + "media/sitemap_page/images/logo01_pc-af788d1520f56a398ebdf67dd1e526ee.png";